import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslate } from 'lib/translate';
import User from '_class/User';
import DateTime from '_class/DateTime';
import { getAttendanceColor } from 'helpers/attendance';

var AttendanceHistory = function AttendanceHistory(_ref) {
  var student = _ref.student;
  var translate = useTranslate();
  var scheduleItem = useSelector(function (state) {
    return state.schedule.activeScheduleItem;
  });
  var absences = [];
  var history = [];
  useMemo(function () {
    if (student == null) {
      return false;
    }

    student.items.forEach(function (item) {
      var reducedItem = _objectSpread({}, item); // Avoid nested references


      delete reducedItem.history;
      delete reducedItem.absences;
      history = [].concat(_toConsumableArray(history), [reducedItem]);

      if (item.absences != null) {
        absences = [].concat(_toConsumableArray(absences), _toConsumableArray(item.absences));
      }

      if (item.history != null) {
        history = [].concat(_toConsumableArray(history), _toConsumableArray(item.history)).filter(function (item) {
          return item.status != 'Deleted';
        });
      }
    });
  }, [student]);

  if (student == null) {
    return null;
  }

  var getIndicator = function getIndicator(attendance) {
    var indicatorColor = getAttendanceColor(attendance);
    return /*#__PURE__*/React.createElement("div", {
      className: "status"
    }, /*#__PURE__*/React.createElement("span", {
      className: "indicator",
      style: {
        backgroundColor: indicatorColor
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "text"
    }, translate(attendance.type.toLowerCase())));
  };

  var getReportedBy = function getReportedBy(item) {
    if (item.reportedBy != null && item.reportedBy.firstName != null) {
      var reportedBy = new User(item.reportedBy);
      return reportedBy.getName();
    }

    if (item.reportedBy != null) {
      if (item.reportedBy.userId == 'TrackAttendance') {
        return translate('system');
      }

      if (item.reportedBy != '') {
        return translate('Guardian');
      }
    }

    return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "form-container attendance-history"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form form-component"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500,
      marginBottom: '0.5rem'
    }
  }, translate('time')), new DateTime(scheduleItem.startTime).getLongDateWithTime().capitalize(), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '0.5rem'
    }
  }, scheduleItem.section != null ? /*#__PURE__*/React.createElement("div", {
    className: "card-meta",
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(Link, {
    style: {
      margin: 0,
      textDecoration: 'none',
      color: '#363636'
    },
    to: "/groups/".concat(scheduleItem.section.id)
  }, scheduleItem.section.title)) : null, scheduleItem.attendanceReported != null ? /*#__PURE__*/React.createElement("div", {
    className: "card-meta",
    style: {
      marginLeft: '0.55rem',
      marginBottom: 0
    }
  }, translate('reported')) : null, /*#__PURE__*/React.createElement("div", {
    className: "clearfix"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-row",
    style: {
      marginTop: '1rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500,
      marginBottom: '0.5rem'
    }
  }, translate('room')), scheduleItem.room), /*#__PURE__*/React.createElement("div", {
    className: "form-row",
    style: {
      marginTop: '1rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500,
      marginBottom: '0.5rem'
    }
  }, translate('week-day')), new DateTime(scheduleItem.startTime).getDay().capitalize()), /*#__PURE__*/React.createElement("div", {
    className: "form-row",
    style: {
      marginTop: '1rem',
      marginBottom: '2rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500,
      marginBottom: '0.5rem'
    }
  }, translate('length')), scheduleItem.length, " ", translate('minutes')), history.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "form-row spacing",
    style: {
      marginTop: '1rem'
    }
  }, /*#__PURE__*/React.createElement("h3", null, translate('Reports on lesson')), /*#__PURE__*/React.createElement("table", {
    className: "x"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translate('Status')), /*#__PURE__*/React.createElement("th", null, translate('Valid absence')), /*#__PURE__*/React.createElement("th", null, translate('Minutes')), /*#__PURE__*/React.createElement("th", null, translate('Reported by')))), /*#__PURE__*/React.createElement("tbody", null, history.map(function (item) {
    return /*#__PURE__*/React.createElement("tr", {
      key: item.id
    }, /*#__PURE__*/React.createElement("td", null, getIndicator(item)), /*#__PURE__*/React.createElement("td", null, item.type != 'PRESENT' ? item.type.indexOf('VALID') == 0 ? translate('Yes') : translate('No') : null), /*#__PURE__*/React.createElement("td", null, item.lateDuration != null && item.lateDuration > 0 ? item.lateDuration : null), /*#__PURE__*/React.createElement("td", null, item.status != 'Deleted' ? getReportedBy(item) : null));
  })))) : null, absences.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "form-row spacing",
    style: {
      marginTop: '1rem'
    }
  }, /*#__PURE__*/React.createElement("h3", null, translate('Reported absence')), /*#__PURE__*/React.createElement("table", {
    className: "x"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translate('Status')), /*#__PURE__*/React.createElement("th", null, translate('Absence length')), /*#__PURE__*/React.createElement("th", null, translate('Valid absence')), /*#__PURE__*/React.createElement("th", null, translate('Reported by')))), /*#__PURE__*/React.createElement("tbody", null, absences.map(function (absence) {
    return /*#__PURE__*/React.createElement("tr", {
      key: absence.id
    }, /*#__PURE__*/React.createElement("td", null, getIndicator(absence)), /*#__PURE__*/React.createElement("td", null, translate('From'), ": ", new DateTime(absence.startTime).getHourStamp(), absence.endTime != null ? /*#__PURE__*/React.createElement("div", null, translate('To'), ": ", new DateTime(absence.endTime).getHourStamp()) : /*#__PURE__*/React.createElement("div", null, translate('To'), ": ", new DateTime(absence.startTime).add(absence.length, 'minutes').getHourStamp())), /*#__PURE__*/React.createElement("td", null, absence.type.indexOf('VALID') == 0 ? translate('Yes') : translate('No')), /*#__PURE__*/React.createElement("td", null, getReportedBy(absence)));
  })))) : null));
};

export default AttendanceHistory;